import { observer } from 'mobx-react';
import React from 'react';
import { BUTTON_TITLE, DEBOUNCE_TIME, STATUS_FILTER } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import { LoadingStatus, TBooleanInNumber } from 'src/types/main';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import UsersList from 'src/view/screens/SettingsScreen/screens/General/ManageUsers/containers/UsersList/UsersList';
import usersStore from 'src/view/screens/SettingsScreen/store/usersStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import './style.scss';

@observer
export default class AllUsers extends React.Component<{}, {}> {
  get options(): IPickerOption[] {
    return [
      { label: localeStore.t(STATUS_FILTER.ACTIVE), value: 1 },
      { label: localeStore.t(STATUS_FILTER.INACTIVE), value: 0 },
    ];
  }

  get selectedOptions(): IPickerOption[] {
    return this.options.filter((option) => usersStore.filters.status?.includes(option.value as TBooleanInNumber));
  }

  selectRole = (options: IPickerOption[]) => {
    usersStore.changeRoles(options);
  };

  changeStatus = (options: IPickerOption[]) => {
    const status = options.map((option) => {
      return option.value as TBooleanInNumber;
    });
    usersStore.setFilters({ status });
  };

  search = (phrase: string = '') => {
    usersStore.setFilters({ search: phrase });
  };

  createUser = () => {
    history.push(SCREENS.SETTINGS_USERS_CREATE());
  };

  render() {
    return (
      <div className="d-flex flex-column full-width flex-grow-1 mt-4">
        <div className="d-flex flex-row mr-4 justify-content-between">
          <div className="d-flex flex-row justify-content-start">
            <SearchInput
              value={usersStore.filters.search || ''}
              onChangeText={this.search}
              loading={[LoadingStatus.Loading, LoadingStatus.Refreshing, LoadingStatus.Init].includes(usersStore.usersLoadingStatus)}
              debounceDelay={DEBOUNCE_TIME.MEDIUM}
              withResetIcon
              customPlaceholder
              placeholder="txt_search"
              className="users_settings-header__search mr-2"
              inputClassName="color-dark text-size-16 family-medium"
            />
            <Picker
              options={this.options}
              selectedOptions={this.selectedOptions}
              onSelect={this.changeStatus}
              placeholder={localeStore.t('select_status')}
              className="mr-2 users_settings-header__filter"
              inputClassName="users_settings-header__filter"
            />
            <Picker
              placeholder={localeStore.t('settings_users_all_user_roles_selected_placeholder')}
              emptyPlaceHolder={localeStore.t('settings_users_select_roles_dropdown')}
              key="branches-picker"
              options={usersStore.rolesOptions}
              selectedOptions={usersStore.selectedRoles}
              onSelect={this.selectRole}
              hideResetIcon
              searchable
              isMulti
              className="users_settings-header__filter"
              inputClassName="users_settings-header__filter"
            />
          </div>
          <Button title={localeStore.t(BUTTON_TITLE.CREATE)} onClick={this.createUser} />
        </div>
        <UsersList />
      </div>
    );
  }
}
